<template>
  <div class="credentials-box container">
    <div class="row header">
      <span>
        {{ $t(getLabel) }}
      </span>
    </div>

    <div class="row">
      <div class="col">
        <div class="body">
          <div class="shop-image">
            <div
              v-if="isIcon"
              class="icon-background">

              <q-icon
                :allowSelfUpdate="false"
                class="image"
                width="24px"
                :pack="getIconPack"
                :name="getIconName" />

            </div>

            <q-image
              v-else
              class="image"
              :pack="getIconPack"
              :name="getIconName" />

          </div>
          <div class="actions-container">
            <slot name="actions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QImage from '@/components/standard/display/QImage'
import QIcon from '@/components/standard/display/QIcon'

import paramExtractor from '@/assets/modules/channels/paramExtractor'

export default {
  computed: {
    /**
     * Gives credentials label
     * @returns {String}
     */
    getLabel () {
      let label = this.credentials.label || (this.credentials.meta || {}).name 
      if (label === 'sqwiz') {
        label = ((this.credentials.meta || {}).viewUrl || '').slice(0, -9)
      }
      return paramExtractor.removeInformacijaPrefix(this.getType, label)
    },

    /**
     * Gives credentials type
     * @returns {String}
     */
    getType () {
      return this.credentials.type
    },

    /**
     * Gives icon+s params
     * @returns {Object}
     */
    getIconParams () {
      return this.iconParams || paramExtractor.extract(this.getType)
    },

    /**
     * Gives icon pack
     * @returns {String}
     */
    getIconPack () {
      return this.getIconParams.pack
    },

    /**
     * gives icon name
     * @returns {String}
     */
    getIconName () {
      return this.getIconParams.icon
    },

    /**
     * Tells if icon component should be used instead
     * @returns {Boolean}
     */
    isIcon () {
      return !!this.credentials.isIcon
    }
  },

  components: {
    'q-image': QImage,
    'q-icon': QIcon
  },

  props: {
    credentials: {
      type: Object,
      required: true,
      default: () => { return {} }
    },

    iconParams: {
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.credentials-box {
  min-height: 230px;
  background-color: #FFF;
}

.credentials-box .header {
  min-height: 50px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #F8F8F8;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.credentials-box .body {
  min-height: 180px;
  padding-top: 25px;
  padding-bottom: 30px;
}

.credentials-box .body .shop-image {
  overflow: hidden;
  text-align: center;
  background-color: #FFF;
  width: 80px;
  height: 80px;
  background-color: #FFF;
  border-radius: 100%;
  margin: 0 auto;
  border: 1px solid #D2D3D4;
  padding: 5px;
}

.credentials-box .body .actions-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-background {
  background-color: #F8F8F8;
  border-radius: 100%;
  width: 68px;
  height: 68px;

  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/CredentialsBox.vue?392ec4d5